import { BookerPreview } from '@duda-co/booking/preview';
import React from 'react';
import useBookingMarkupData from '../../../hooks/useBookingMarkupData';

/**
 * Static, fetch-free preview for the native booker (shown when no event is
 * active). Feeds the lib's `BookerPreview` primitive from the shared markup
 * mock so the placeholder matches the legacy `BookingMarkup`. Imported
 * statically (not lazy) so it renders immediately.
 */
const NativeBookingMarkup = () => {
    const { mockInfo } = useBookingMarkupData();

    return (
        <BookerPreview
            title={mockInfo.eventName}
            duration={mockInfo.data[0]?.value}
        />
    );
};

export default NativeBookingMarkup;
